import { Button, pxToRem, useStyles, useTheme } from '@archipro-design/aria';
import {
    AddLine,
    HeartLine,
    HeartFill,
    TimesLight,
} from '@archipro-design/icons';
import * as S from './PaintColourActions.style';
import SaveToDesignBoard from '~/modules/design-board/component/SaveToDesignBoard';
import { useSaveToDesignBoard } from '~/modules/design-board';
import { useTracker } from '@archipro-website/tracker';
import { usePaintPickerContext } from '@modules/paint-picker/context/PaintPickerContext';
import { useHandleFollow } from '~/modules-rocco/design-board/hook/use-handle-follow';

interface PaintColourActionsProps {
    show: boolean;
    isPreview?: boolean;
    id: number;
    title: string;
    productId: number;
    onOpenDesignBoard?: () => void;
    onCloseDesignBoard?: () => void;
}

const PaintColourActions = ({
    show,
    isPreview,
    id,
    title,
    productId,
    onOpenDesignBoard,
    onCloseDesignBoard,
}: PaintColourActionsProps) => {
    const { css } = useStyles({ show });
    const theme = useTheme();
    const tracker = useTracker();
    const { removePaint } = usePaintPickerContext();
    const { favouriteItem } = useSaveToDesignBoard('ProductPin', productId);
    const { isInDesignBoard } = useHandleFollow();

    if (isPreview) {
        return (
            <div className={css(S.Actions)}>
                <Button
                    className={css(S.AddButton)}
                    size={16}
                    color={'grey'}
                    variables={{
                        buttonPadding: 8,
                        buttonRadius: '50%',
                        iconPadding: 0,
                    }}
                    icon={
                        <AddLine
                            color={theme.siteVariables.colors.charcoal[300]}
                            size="1x"
                        />
                    }
                />
            </div>
        );
    }

    return (
        <div className={css(S.Actions)}>
            <SaveToDesignBoard
                {...favouriteItem}
                autoReposition={true}
                onClose={onCloseDesignBoard}
                offsetLeft={pxToRem(0)}
                onSave={(favouritedItem) => {
                    // when signed out this fires twice, we want to track when the item has been added to a board.
                    if (favouritedItem && favouritedItem.boardId > 0) {
                        tracker.log('Resene-Colour-Added-DesignBoard', {
                            url: new URL(window.location.href),
                            targetTracker: 'archiproTracker',
                            data: {
                                ExtraData: title,
                            },
                        });
                    }
                }}
            >
                <Button
                    size={16}
                    color={'grey'}
                    variables={{
                        buttonPadding: 4,
                        buttonRadius: '50%',
                    }}
                    onClick={onOpenDesignBoard}
                    icon={
                        isInDesignBoard(productId, 'ProductPin') ? (
                            <HeartFill size="1x" as="figure" />
                        ) : (
                            <HeartLine size="1x" as="figure" />
                        )
                    }
                />
            </SaveToDesignBoard>
            <Button
                className={css(S.RemoveButton)}
                size={16}
                color={'grey'}
                variables={{
                    buttonPadding: 4,
                    buttonRadius: '50%',
                }}
                onClick={() => removePaint(id)}
                icon={<TimesLight size="1x" as="figure" />}
            />
        </div>
    );
};

export default PaintColourActions;
